module.exports = function(dashboard) {
	'use strict'
	dashboard.directive('dashboardDir', dashboardDir);
	dashboardDir.$inject=[];
	function dashboardDir() {
		return {
			template: require('./partials/dashboardTemplate.html'),
			controller:'dashboardController',
			controllerAs:'vmd',
			link: function(scope, element, attrs) {
				
			}
		};
	};
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/dashboardModule/js/directive/dashboardDirective.js
// module id = 501
// module chunks = 0